export const ACTIONS = {
  CHANGE_TAB: 'main_tabs/change_tabs',
};

export default function changeTab(value) {
  return dispatch => {
    dispatch({ type: ACTIONS.CHANGE_TAB, ...value });
  };
}
